const LOADED_CLASS = 'is--loaded';

const useLoadingState = (element: Element) => {
    const loadingState = element.querySelector('[js-hook-loading-state]');

    return {
        setLoaded: () => {
            element.classList.add(LOADED_CLASS);

            loadingState?.addEventListener('animationend', () => {
                loadingState?.remove();
            });
        },
    };
};

export default useLoadingState;
